import { Button, Modal, Row, Table } from 'antd';

import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { useCapturePostHog } from '../../../../hooks/useCapturePostHog';
import type { SortedInfo } from '../../../../models/table';
import type { TimeInStatus } from '../programDashboardSlice';
import type { DashboardModalType } from './modalDashboardSlice';
import { clearModalFilter, closeDashboardModal, DASHBOARD_MODAL, handleModalTableChange } from './modalDashboardSlice';
import { GetTimeInRiskModalProps } from './time-in-risk-modal-props';

export const TimeInRiskModal = ({ data, filtersInfo }: { data: TimeInStatus[]; filtersInfo: string }) => {
  const dispatch = useAppDispatch();
  const { capturePostHogCustomEvent } = useCapturePostHog();
  const open = useAppSelector((state) => state.modalDashboardSlice.modal === DASHBOARD_MODAL.TIME_IN_RISK);
  const { columns, clearSearch } = GetTimeInRiskModalProps();

  return (
    <Modal
      className="dashboardModal"
      width={'80%'}
      title="Time spent in risk status details"
      open={open}
      onCancel={() => {
        capturePostHogCustomEvent('TimeInRiskModal close modal');
        dispatch(closeDashboardModal());
      }}
      mask={{ blur: false, closable: false }}
      footer={null}
    >
      <Row className="filtersInfoRow" justify="space-between" align="middle">
        <p style={{ marginTop: 'auto', marginBottom: 'auto' }}>{filtersInfo}</p>
        <Button
          onClick={() => {
            dispatch(clearModalFilter());
            clearSearch();
            dispatch(
              handleModalTableChange({
                sorter: {
                  columnKey: 'full_name',
                  field: 'full_name',
                  order: 'ascend',
                },
              }),
            );
            capturePostHogCustomEvent('TimeInRiskModal clear filters');
          }}
        >
          Clear filters
        </Button>
      </Row>
      <Table
        className="dashboardTable"
        columns={columns}
        rowKey="client_id"
        onChange={(pagination, filters, sorter) => {
          dispatch(handleModalTableChange({ pagination, filters, sorter: sorter as SortedInfo<DashboardModalType> }));
          capturePostHogCustomEvent('TimeInRiskModal table change');
        }}
        pagination={
          data.length > 20
            ? {
                showTotal: (total, range) => {
                  return `Showing ${range[0]}-${range[1]} of ${total} results`;
                },
                placement: ['bottomEnd'],
                defaultPageSize: 20,
              }
            : false
        }
        dataSource={data}
        scroll={{ y: 'calc(100vh - 400px)' }}
      />
    </Modal>
  );
};
